import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6838f44&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/confirm/_confirm.scss?vue&type=style&index=0&id=f6838f44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6838f44",
  null
  
)

export default component.exports